import React, { useContext } from 'react';

import { fetchMoreTasksAction } from 'actions/task';
import { useParsedQuery } from 'components/hooks/useParsedQuery';
import { useSelector, shallowEqual } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { selectMeshListGlobalFilters, selectTeamPageGlobalFilters } from 'selectors/globalFilters';
import styled from 'styled-components';
import { StyledTypography } from 'styles/common';

import { getTeamMatch, getTagPageMatch } from 'constants/helper';

import MeshListContext from './MeshListContext';
import { ListItemCSS } from './styles';

export default function LoadMore({ type, pageType = null, timeBoundPeriod = null }) {
  const history = useHistory();
  const isTeamPage = getTeamMatch(history.location.pathname);
  const isTagPage = getTagPageMatch(history.location.pathname);
  const globalFilters = useSelector(
    (state) => (isTeamPage || isTagPage ? selectTeamPageGlobalFilters(state) : selectMeshListGlobalFilters(state)),
    shallowEqual
  );

  const { dispatch } = useContext(MeshListContext);
  const parsedSearch = useParsedQuery(history?.location?.search);

  if (parsedSearch?.teamName === 'My Initiatives') {
    globalFilters.teamId = -1;
  }

  return (
    <Container>
      <StyledTypography
        onClick={() => dispatch(fetchMoreTasksAction({ type, globalFilters, pageType, timeBoundPeriod }))}
        color="primary"
        style={{ fontSize: '14px' }}
      >
        Load More
      </StyledTypography>
    </Container>
  );
}

const Container = styled.div`
  ${ListItemCSS};
`;
